import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import LifestyleCardModal from "./LifestyleCardModal";

function LifestyleCard({ post, activeIndex, setActiveIndex }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => {
    setActiveIndex((prevState) => ({
      ...prevState,
      [post.id]: 0,
    }));
  };

  return (
    <>
      {/* CARD */}
      <div
        className="local-theme-bg-md local-theme-border-md rounded-lg shadow-lg overflow-hidden group cursor-pointer select-none"
        onMouseEnter={handleMouseEnter}
        onClick={() => setIsOpen(true)}
      >
        <div className="relative w-full h-48">
          <Carousel
            selectedItem={activeIndex[post.id] || 0}
            showThumbs={false}
            infiniteLoop
            autoPlay
            showArrows={false}
            showStatus={false}
            interval={2000}
            className="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          >
            {post.images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${post.title} ${index + 1}`}
                className="w-full h-48 object-cover"
              />
            ))}
          </Carousel>

          <img
            src={post.images[0]}
            alt={post.title}
            className="w-full h-48 object-cover group-hover:opacity-0 transition-opacity duration-300"
          />
        </div>

        <div className="p-4">
          <h2 className="text-xl font-semibold local-theme-text-md">
            {post.title}
          </h2>
          <p className="local-theme-text-xs mt-2">{post.description}</p>
        </div>
      </div>

      {/* MODAL COMPONENT */}
      <LifestyleCardModal
        post={post}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}

export default LifestyleCard;
